<template>
	<v-row align="center" justify="center">
		<v-col cols="4">
			<v-menu
				v-model="menu"
				:close-on-content-click="false"
				:nudge-width="50"
				offset-overflow
			>
				<template v-slot:activator="{ on, attrs }">
					<v-card outlined>
						<v-card-text>
							<div v-bind="attrs" v-on="on">
								<v-btn :disabled="loading" outlined fab small text>
									<v-icon color="primary">mdi-map-marker-check-outline</v-icon>
								</v-btn>
								<div class="body-2" v-if="$vuetify.breakpoint.smAndUp">
									Solicitar ubicación
								</div>
							</div>
						</v-card-text>
					</v-card>
				</template>
				<v-card :class="globalBackground">
					<v-card-title>
						¿Como deseas solicitarla?
					</v-card-title>
					<v-divider />
					<v-card-actions>
						<v-radio-group v-model="radioGroup">
							<v-radio label="Compartida o señalada" :value="0"></v-radio>
							<v-radio label="Solo compartida del celular" :value="1"></v-radio>
							<v-radio label="Solo ubicación señalada" :value="2"></v-radio>
							<!-- <v-radio label="Asistencia" :value="3"></v-radio> -->
						</v-radio-group>
					</v-card-actions>
					<v-card-actions>
						<v-btn
							:loading="loading"
							block
							color="primary"
							@click="sendGpsConfirmation(radioGroup == 3 ? 'asi' : 'gps')"
							>Enviar</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-menu>
		</v-col>
		<v-col cols="4">
			<v-card outlined>
				<v-card-text>
					<v-btn
						:disabled="loading"
						outlined
						fab
						small
						text
						@click="sendStatusConfirmation()"
					>
						<v-icon color="primary">mdi-cellphone-message</v-icon>
					</v-btn>
					<div class="body-2" v-if="$vuetify.breakpoint.smAndUp">Confirmar actividad</div>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'confirmationButton',
	props: {
		lodgingId: { type: String, required: true },
		personId: { type: String, required: true },
		placeName: { type: String, required: true },
		isUser: { type: Boolean, default: false },
		hasPhone: { type: Boolean, default: false },
	},
	data() {
		return { radioGroup: 0, menu: false, loading: false };
	},
	methods: {
		/**
		 * send sms confirmation type sms or gps
		 */
		async notificationPush(notificationType) {
			this.menu = false;
			this.loading = !this.loading;
			await this.sendSmsConfirmation({
				lodgingId: this.lodgingId,
				type: notificationType,
				handler: this.radioGroup == 3 ? 1 : this.radioGroup,
				subtitle: `${this.placeName} esta esperando, ingresa a www.kronogram.cl`,
				currentRoute: this.$route.name,
			});
			this.loading = !this.loading;
		},
		async sendStatusConfirmation() {
			await this.notificationPush('sms');
		},
		async sendGpsConfirmation() {
			await this.notificationPush('gps');
		},
		...mapActions({
			sendSmsConfirmation: 'Lodging/sendSmsConfirmation',
		}),
	},
};
</script>

<style scoped>
.fontSubtitle {
	font-size: 10px;
}
</style>
